import axios from "axios";
import { auth } from "./firebase";

const api = axios.create({
  baseURL:
    process.env.VUE_APP_API_URL ||
    "https://us-central1-aejmis-afee9.cloudfunctions.net",
  headers: {},
});

/**
 * The data endpoints require a Firebase ID token, and they additionally require
 * that the token carries a completed two-factor check. Attaching the token here
 * means every call site gets the header without changing its own code.
 *
 * The token is read per request rather than cached, so the `twoFactorAt` claim
 * set after a successful 2FA check is picked up automatically.
 */
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;

  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

/**
 * A rejected session (2FA not completed, verification expired, or the token
 * rejected) should not leave the app in a half-authenticated state, so sign the
 * user out and send them back to the login screen.
 */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response && error.response.status;
    const data = (error.response && error.response.data) || {};
    const code = data.code;

    if (status === 401 || code === "2FA_REQUIRED" || code === "2FA_EXPIRED") {
      const { signOut } = await import("firebase/auth");
      await signOut(auth);
      if (typeof window !== "undefined" && window.location.pathname !== "/") {
        window.location.assign("/");
      }
    }

    return Promise.reject(error);
  }
);

export default api;
